import { useState } from 'react';
import { SkillCard } from './SkillCard';
import { Label } from 'src/components/Label';
import { Input } from 'src/components/Input';

type EcommerceShoppingConfig = {
  store_domain?: string;
};

export const EcommerceShoppingSkill = ({
  config,
  onConfigChange,
}: {
  config: EcommerceShoppingConfig;
  onConfigChange?: (config: EcommerceShoppingConfig) => void;
}) => {
  const [storeDomain, setStoreDomain] = useState<string | undefined>(
    config.store_domain,
  );

  return (
    <SkillCard title="SHOPIFY SHOPPING">
      <div className="flex mt-2 gap-4">
        <div>
          <Label>Store Domain</Label>
          <Input
            value={storeDomain}
            placeholder="www.example.com"
            onChange={(e) => {
              onConfigChange?.({ store_domain: e.target.value });
              setStoreDomain(e.target.value);
            }}
          />
        </div>
      </div>
    </SkillCard>
  );
};
